import { css } from '@emotion/react'
import compact from 'lodash/compact'

function Icon(props: { className?: string; name: string; data: string }) {
  if (import.meta.env.NODE_ENV === 'test') {
    return <i data-icon={props.name} />
  }

  return (
    <svg
      className={compact(['tw-icon', props.className]).join(' ')}
      viewBox="0 0 1000 1000"
      css={css`
        display: inline-block;
        color: inherit;
        width: 1em;
        height: 1em;
        flex-shrink: 0;
        user-select: none;
      `}
      data-icon={props.name}
    >
      <path transform="scale(1,-1) translate(0,-950)" fill="currentColor" d={props.data} />
    </svg>
  )
}

export function createIcon(componentName: string, originalName: string, data: string) {
  const Component = function (props: Omit<React.ComponentProps<typeof Icon>, 'name' | 'data'>) {
    return <Icon {...props} name={originalName} data={data} />
  }
  Component.displayName = componentName
  return Component
}
